import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';
import '@fontsource/noto-sans';
import "@fontsource/source-code-pro";

import './theme.scss';
import './hljs.scss';

const codeNodes = document.querySelectorAll('pre > code[class*="language-"]');
const mermaidNodes = document.querySelectorAll('pre.mermaid');

if (codeNodes.length > 0) {
  highlightCode(codeNodes);
}
if (mermaidNodes.length > 0) {
  renderMermaid(mermaidNodes);
}

// lib/common covers the mainstream languages at a fraction of the size
// of the full highlight.js build.
async function highlightCode(nodes) {
  const {default: hljs} = await import('highlight.js/lib/common');

  for (const node of nodes) {
    hljs.highlightElement(node);
  }
}

async function renderMermaid(nodes) {
  const {default: mermaid} = await import('mermaid');

  // Lazy loader: the icon JSON is only fetched on pages whose diagrams
  // actually reference a tabler:* icon.
  mermaid.registerIconPacks([{
    name: 'tabler',
    loader: () => import('@iconify-json/tabler').then(module => module.icons),
  }, {
    name: 'simple-icons',
    loader: () => import('@iconify-json/simple-icons').then(module => module.icons),
  }]);

  // Custom properties hold unresolved light-dark() expressions; resolve
  // them to concrete colours through a probe element.
  const probe = document.createElement('span');
  document.body.appendChild(probe);
  const resolve = (variable) => {
    probe.style.color = `var(${variable})`;
    return getComputedStyle(probe).color;
  };

  mermaid.initialize({
    startOnLoad: false,
    theme: 'base',
    themeVariables: {
      darkMode: matchMedia('(prefers-color-scheme: dark)').matches,
      background: resolve('--color-bg0'),
      primaryColor: resolve('--color-bg1'),
      primaryTextColor: resolve('--color-fg0'),
      primaryBorderColor: resolve('--color-fg4'),
      secondaryColor: resolve('--color-bg2'),
      tertiaryColor: resolve('--color-bg0-soft'),
      lineColor: resolve('--color-fg2'),
      // The base theme defaults these to #000/#777 instead of deriving
      // them from primaryBorderColor/lineColor like other diagrams.
      archGroupBorderColor: resolve('--color-fg4'),
      archEdgeColor: resolve('--color-fg2'),
      archEdgeArrowColor: resolve('--color-fg2'),
      fontFamily: '"Noto Sans", sans-serif',
    },
  });
  probe.remove();

  await mermaid.run({nodes: nodes});
}
